import { StyleSelector } from 'components/styles/primitives/modifiers/types'
import { css } from '@emotion/react'

export const ifBefore: StyleSelector = styles => css`
	&:before {
		${styles}
	}
`
